import React from 'react'
import { apiFetch } from './fetchApi'

export const fetchEodSubmission = async  ({ BeURL, showAlert, setEodList, id, searchTerm }) => {
    try {
        const res = await apiFetch(`${BeURL}/fetch-eod-submission-reports?currentuser=${id}&&searchTerm=${searchTerm}`, {
            method: "GET",
            credentials: "include",
        });
        const data = await res.json();
        if (data.success) {
            setEodList(data?.eod)
            
        } else {
            showAlert(data.message);
        }
    } catch (err) {
        console.error("Error in fetch job:", err);
        showAlert("Failed to fetch jobs", "error");
    }
}
